import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreButton from 'components/consumer/LoadMoreButton';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import getFirstFocusableElement from 'hooks/helpers/getFirstFocusableElement';
import MixedGridCardPlaceholder from './components/MixedGridCardPlaceholder';
import MixedGridItems from './components/MixedGridItems';
import MixedGridItemsWithReviews from './components/MixedGridItemsWithReviews';
const MixedGrid = t0 => {
  const $ = _c(20);
  const {
    allData,
    gridWithOneCol,
    gridWithReviews,
    hits,
    hoveredValue,
    keyId,
    layout,
    loading,
    loadingMore,
    loadMore,
    isMixedGridTab,
    maxCardsCount: t1,
    onHoverHandler,
    toggleModalView,
    allStaticProductData: t2
  } = t0;
  const maxCardsCount = t1 === undefined ? 6 : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const allStaticProductData = t3;
  const itemContainerRef = useRef();
  let t4;
  if ($[2] !== allData || $[3] !== allStaticProductData || $[4] !== gridWithOneCol || $[5] !== gridWithReviews || $[6] !== hits || $[7] !== hoveredValue || $[8] !== isMixedGridTab || $[9] !== layout || $[10] !== loadMore || $[11] !== loading || $[12] !== loadingMore || $[13] !== maxCardsCount || $[14] !== onHoverHandler || $[15] !== toggleModalView) {
    t4 = <div className="mx-auto my-0" ref={itemContainerRef}>{loading ? <div className={classNames("grid gap-[10px] max-[767px]:mt-2 md:gap-4 min-[1200px]:grid-cols-[repeat(auto-fit,minmax(300px,33.333%))] max-[767px]:[&>*]:max-w-[100vw]", {
        "xl:grid-cols-[repeat(auto-fit,minmax(45%,1fr))] xl:m-0": isMixedGridTab
      })}><MixedGridCardPlaceholder maxCardsCount={maxCardsCount} /></div> : <><InfiniteScroll dataLength={allData && allData.length} next={loadMore} hasMore={!!loadMore}>{gridWithReviews ? <MixedGridItemsWithReviews loadingMore={loadingMore} data={allData} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} isMixedGridTab={isMixedGridTab} allStaticProductData={allStaticProductData} /> : gridWithOneCol ? <div className="flex flex-col"><MixedGridItems from="review" loadingMore={loadingMore} data={allData} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} /></div> : <div className={classNames("grid gap-[10px] max-[767px]:mt-2 md:gap-4 min-[1200px]:grid-cols-[repeat(auto-fit,minmax(300px,33.333%))]", {
            "xl:grid-cols-[repeat(auto-fit,minmax(45%,1fr))] xl:m-0": isMixedGridTab
          })}><MixedGridItems loadingMore={loadingMore} data={allData} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} /></div>}</InfiniteScroll>{!loadingMore && loadMore && <><VisuallyHidden>On activating the Load more items button, the content above will be updated</VisuallyHidden><LoadMoreButton onClick={() => {
            loadMore();
            const firstFocusableElement = getFirstFocusableElement(itemContainerRef.current);
            if (firstFocusableElement) {
              firstFocusableElement.focus();
            }
          }} aria-label="Load more items" /></>}</>}</div>;
    $[2] = allData;
    $[3] = allStaticProductData;
    $[4] = gridWithOneCol;
    $[5] = gridWithReviews;
    $[6] = hits;
    $[7] = hoveredValue;
    $[8] = isMixedGridTab;
    $[9] = layout;
    $[10] = loadMore;
    $[11] = loading;
    $[12] = loadingMore;
    $[13] = maxCardsCount;
    $[14] = onHoverHandler;
    $[15] = toggleModalView;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== keyId || $[18] !== t4) {
    t5 = <div data-xc="mixed-grid" className="mixed-grid" key={keyId}>{t4}</div>;
    $[17] = keyId;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
MixedGrid.propTypes = {
  allData: PropTypes.array,
  allStaticProductData: PropTypes.array,
  gridWithOneCol: PropTypes.bool,
  gridWithReviews: PropTypes.number,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  isMixedGridTab: PropTypes.bool,
  keyId: PropTypes.string,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  loadMore: PropTypes.func,
  maxCardsCount: PropTypes.number,
  onHoverHandler: PropTypes.func,
  toggleModalView: PropTypes.func
};
export default MixedGrid;